import { ronin as viemRonin } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const ronin = {
  displayName: 'Ronin',
  runtime: 'evm',
  viemChain: viemRonin,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'ronin' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
